import "../styles/Footer.css";
import logo from "../img/my-stamp.png";

function Footer() {
  return (
    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-cta">
          <h2 class="footer-heading">Let's build something together.</h2>
          <a href="https://wa.me/8622498300" class="footer-button">
            Get in touch
          </a>
        </div>

        <div class="footer-brand">
          <img src={logo} alt="logo" class="footer-logo" />

          <p class="footer-label">Development and Designs</p>
          <p class="footer-tagline">
            Freelance web developer &amp; designer based in NJ.
          </p>
        </div>

        <div class="footer-bottom">
          <p>© 2026 Mike — Development and Designs</p>
          <a href="#top" class="footer-back-to-top">
            Back to top <span aria-hidden="true">↑</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
